import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pm2bpwd5bfh1">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-20" data-mp="avld0krwb3nu">
          <span aria-hidden="true" data-id="element-21" data-mp="ft4r9kolfgfs">🎁 </span>5 Exclusive Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-stone-600" data-id="element-22" data-mp="1tvk1aid7wny">
          Valued at{' '}
          <span className="font-bold text-amber-600 line-through" data-id="element-23" data-mp="5vqnakjuwk4d">
            $87 USD
          </span>{' '}
          — Included <span className="font-bold text-red-500" data-id="element-24" data-mp="3o2eldqgho70j">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-25" data-mp="3t0g6egxh6gen">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-sm" data-id="element-26" data-mp="1ma8mz24kp64a" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-500 text-sm font-bold text-white" data-id="element-27" data-mp="1r8a1rauyuj9y">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-28 w-[84px] shrink-0 rounded-lg object-cover shadow-md sm:h-36 sm:w-28" data-id="element-28" data-mp="3dg4wwqwi3shk" />
              <div data-id="element-29" data-mp="3n4mxp84s5zl7">
                <h3 className="text-sm font-bold leading-snug text-stone-900 sm:text-base" data-id="element-30" data-mp="3n6g2ehvu29qk">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-bold" data-id="element-31" data-mp="2zheztb9olst7">
                  <span className="text-amber-600 line-through" data-id="element-32" data-mp="2uhsleyi4a6it">
                    was {bonus.was}
                  </span>{' '}
                  <span className="text-red-500" data-id="element-33" data-mp="38dw2dq3zcidc">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}